import { Position, HandleType, Handle } from "@xyflow/react";
import React from "react";
import classNames from "classnames";
import Styles from "./BaseHandle.module.scss";

interface HandleProps {
    id: string;
    type: HandleType;
    position: Position;
}

export default function BaseHandle(props: HandleProps) {
    const { id, type, position } = props;

    return (
        <Handle
            type={type}
            position={position}
            id={id}
            className={classNames(Styles["base-handle"], {
                [Styles["base-handle-bottom"]]: position === Position.Bottom,
            })}
        />
    );
}
